import { render, staticRenderFns } from "./TokenCliente.vue?vue&type=template&id=dd93624a&"
import script from "./TokenCliente.vue?vue&type=script&lang=js&"
export * from "./TokenCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports